var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmarkcircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5.8359 -75.6582 80.8575 80.8086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.4766 85.6934-35.2539C85.6934-57.0312 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-57.0312 6.83594-35.2539C6.83594-13.4766 24.5117 4.15039 46.2402 4.15039ZM46.2402-3.27148C28.5645-3.27148 14.3066-17.5781 14.3066-35.2539C14.3066-52.9297 28.5645-67.2363 46.2402-67.2363C63.916-67.2363 78.2227-52.9297 78.2227-35.2539C78.2227-17.5781 63.916-3.27148 46.2402-3.27148Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.791-19.873L61.5723-45.6543C62.207-46.2891 62.5977-47.1191 62.5977-48.0469C62.5977-50 61.0352-51.5137 59.1309-51.5137C58.1543-51.5137 57.373-51.1719 56.7383-50.4883L30.9082-24.8047C30.2734-24.1211 29.8828-23.3398 29.8828-22.3633C29.8828-20.4102 31.4453-18.8477 33.3496-18.8477C34.375-18.8477 35.2051-19.2383 35.791-19.873ZM56.6406-19.873C57.2754-19.2383 58.1055-18.8477 59.1309-18.8477C61.0352-18.8477 62.5977-20.4102 62.5977-22.3633C62.5977-23.3398 62.207-24.1211 61.5723-24.8047L35.7422-50.4883C35.1074-51.1719 34.3262-51.5137 33.3496-51.5137C31.4453-51.5137 29.8828-50 29.8828-48.0469C29.8828-47.1191 30.2734-46.2891 30.9082-45.6543Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkcircle);
export default __webpack_public_path__ + "static/media/xmark.circle.9b3f3b365b74ca39ca9ff16a16b4d6d7.svg";
export { ForwardRef as ReactComponent };